<template>
     <div class="main-content">
         <div class="banner-flutuante" v-if="cover && cover.enable_float">
            <button @click="cover.enable_float=false"></button>
            <a href="javascript:;">
                <div id='div-gpt-ad-1611161341576-0'></div>
            </a>
        </div>
         <div class="container container-banner">
             <div class="row">
                 <div class="col-12">
                     <!-- v1_gweb_superbanner_topo -->
                     <div id='div-gpt-ad-1603501550614-0'></div>
                 </div>
             </div>
         </div>
         <div class="container container-first-call" v-if="home && home.urgent_feature && home.urgent_feature.length">
            <div class="row" v-for="urgent in home.urgent_feature" :key="urgent.id">
                <div class="col-12 col-md-3 col-lg-2 first-call__disclaimer-wrapper" >
                    <p class="first-call__disclaimer">{{urgent.urgent_label}}</p>
                </div>
                <div class="col-12 col-md-9 col-lg-10 first-call__info-wrapper">
                    <SuperLink :href="urgent.link" class="first-call__info">
                        {{urgent.title}}
                    </SuperLink>
                </div>
            </div>
        </div>

        <template v-if="home">
            <Header01 
                v-if="home.style == 'template_1'"
                :slider="slider" 
                :main="main" 
                :simple="simple" 
                :small="small" />
            
            <Header02 
                v-else-if="home.style == 'template_2'"
                :slider="slider" 
                :main="main" 
                :small="small" />
            
            <Header03 
                v-else-if="home.style == 'template_3'"
                :main="main" 
                :simple="simple" 
                :big="big"
                :small="small"
                :related="related" />
            
            <Header04 
                v-else-if="home.style == 'template_4'"
                :slider="slider" 
                :main="main" 
                :simple="simple" 
                />
            
            <Header05 
                v-else-if="home.style == 'template_5'"
                :full="full"
                :main="main" 
                :simple="simple" 
                :big="slider"
                :small="small"
                :related="related"
                />
        </template>

        

        <div class="container" v-else>
            <div class="row">
                <div class="col-12">
                    <content-loader 
                        class=""
                        style="margin: 40px auto; display:block"
                        width="1100"
                        height="610">

                        <rect x="1" y="1" rx="0" ry="0" width="530" height="60" />
                        <rect x="1" y="70" rx="0" ry="0" width="530" height="60" />
                        <rect x="1" y="140" rx="0" ry="0" width="530" height="60" />

                        <rect x="1" y="250" rx="0" ry="0" width="400" height="30" />
                        <rect x="1" y="300" rx="0" ry="0" width="400" height="30" />

                        <rect x="560" y="1" rx="0" ry="0" width="255" height="350" /> 
                        <rect x="840" y="1" rx="0" ry="0" width="255" height="200" /> 

                        <rect x="840" y="230" rx="0" ry="0" width="80" height="15" /> 
                        <rect x="840" y="255" rx="0" ry="0" width="255" height="20" /> 
                        <rect x="840" y="280" rx="0" ry="0" width="255" height="20" /> 
                        <rect x="840" y="305" rx="0" ry="0" width="255" height="20" /> 

                        <template v-for="(i, key) in 6">
                            <rect :x="1+(key*187)" y="400" rx="0" ry="0" width="160" height="104" :key="`image-${key}`" /> 
                            <rect :x="1+(key*187)" y="520" rx="0" ry="0" width="80" height="15" :key="`date-${key}`" /> 
                            <rect :x="1+(key*187)" y="550" rx="0" ry="0" width="160" height="17" :key="`title1-${key}`" /> 
                            <rect :x="1+(key*187)" y="573" rx="0" ry="0" width="160" height="17" :key="`title2-${key}`" /> 
                            <rect :x="1+(key*187)" y="595" rx="0" ry="0" width="160" height="17" :key="`title3-${key}`" /> 
                        </template>
                    </content-loader>
                </div>
            </div>
        </div>
        <Fixed :fixed="fixed" :fixed_images="fixed_images" :cover="cover" />

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <!-- v1_gweb_home_bloco_1 -->
                    <div id='div-gpt-ad-1603501676998-0'></div>
                </div>
            </div>
        </div>

        <Blogs class="--hide-mobile" />

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <!-- v1_gweb_home_bloco_2 -->
                    <div id='div-gpt-ad-1603501815620-0'></div>
                </div>
            </div>
        </div>

        <Extra :content="extra" />
        <Politica />

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <!-- v1_gweb_home_bloco_3 -->
                    <div id='div-gpt-ad-1603501923878-0'></div> 
                </div>
            </div>
        </div>

        <Diversao />
        <!-- <Agenda />
        <Cinema /> -->

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <!-- v1_gweb_home_bloco_4 -->
                    <div id='div-gpt-ad-1603501972574-0'></div>
                </div>
            </div>
        </div>

        <Esportes />
        <!-- <Time /> -->

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <!-- v1_gweb_home_bloco_5 -->
                    <div id='div-gpt-ad-1603502015774-0'></div>
                </div>
            </div>
        </div>

        <Videos />
        <!-- <Classificados /> -->
        <br />

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <!-- v1_gweb_home_bloco_6 -->
                    <div id='div-gpt-ad-1603502060044-0'></div>
                </div>
            </div>
        </div>

        <Listas />

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <!-- v1_gweb_rodape -->
                    <div id='div-gpt-ad-1603502217781-0'></div>
                </div>
            </div>
        </div>

        <ins class='hstpnetworkads' style='display: none; width: 300px; height: 600px'></ins> 
        
     </div>

     
     
</template>

<script>
import home from '@/store/home'
import Header01 from '@/components/home/header/Header01'
import Header02 from '@/components/home/header/Header02'
import Header03 from '@/components/home/header/Header03'
import Header04 from '@/components/home/header/Header04'
import Header05 from '@/components/home/header/Header05'

import Blogs from '@/components/home/Blogs'
import Politica from '@/components/home/Politica'
import Diversao from '@/components/home/Diversao'
// import Agenda from '@/components/home/Agenda'
// import Cinema from '@/components/home/Cinema'
import Extra from '@/components/home/Extra'
import Esportes from '@/components/home/Esportes'
// import Time from '@/components/home/Time'
import Videos from '@/components/home/Videos'
import Fixed from '@/components/home/Fixed'
// import Classificados from '@/components/home/Classificados'
import Listas from '@/components/home/Listas'

import SuperLink from '@/components/SuperLink'

import { ContentLoader } from 'vue-content-loader'


export default {
    name: 'Home',
    props:['content'],
    components:{
        Header01,
        Header02,
        Header03,
        Header04,
        Header05,
        Blogs,
        Politica,
        Diversao,
        // Agenda,
        // Cinema,
        Extra,
        Esportes,
        // Time,
        Videos,
        Fixed,
        // Classificados,
        Listas,
        SuperLink,
        ContentLoader,
    },
    head:{
        title:{
            inner: 'Home'
        }
    },
    data: function () {
        return {
            slider: [],
            full: {},
            main:{},
            simple: {},
            small: [],
            big:[],
            related:[],
            fixed: [],
            fixed_images: [],
            cover: null,
            extra: null,
        }
    },
    computed: {
        home: function() {
            return home.getters.all
        },
        features_index: function() {
            let indexes = {}
            if (this.main) {
                indexes[this.main.id] = {type:'main'}
            }
            if (this.small.length){
                this.small.forEach((sm,k) => {
                    indexes[sm.id] = {type:'small', key:k}
                })
            }
            if (this.big.length){
                this.big.forEach((sm,k) => {
                    indexes[sm.id] = {type:'big', key:k}
                })
            }
            if (this.fixed.length){
                this.fixed.forEach((sm,k) => {
                    indexes[sm.id] = {type:'fixed', key:k}
                })
            }
            if (this.fixed_images.length){
                this.fixed_images.forEach((sm,k) => {
                    indexes[sm.id] = {type:'fixed_images', key:k}
                })
            }
            if (this.slider.length){
                this.slider.forEach((sm,k) => {
                    indexes[sm.id] = {type:'slider', key:k}
                })
            }
            if (this.related.length){
                this.related.forEach((sm,k) => {
                    indexes[sm.id] = {type:'related', key:k}
                })
            }
            return indexes
        }
    },
    watch: {
        home: function() {
            this.fill()
        }
    },
    methods: {
        async getHome() {
            let now = new Date()
            if (home.state.data_expires_at && home.state.data_expires_at < now) {
                await home.dispatch('getHome')
            }
        },
        fill() {
            if (this.home) {
                this.full = this.home.full_feature
                this.slider = this.home.slider_feature
                this.small = this.home.small_feature
                this.big = this.home.big_feature
                this.fixed = this.home.fixed_feature
                this.fixed_images = this.home.fixed_images_feature
                this.cover = this.home.gazeta_cover
                this.main = this.home.main_feature
                this.simple = this.home.simple_feature
                this.related = this.home.related_feature

                if (this.home.extra_content) {
                    this.extra = this.home.extra_content
                }
            }
        },
        sortFeature(arr) {
            return arr.slice(0).sort((a,b) => {
                const date_a = new Date(a.date)
                const date_b = new Date(b.date)
                return date_a < date_b ? 1 : -1
            })
        },
        deleteOriginal(id) {
            if (id in this.features_index) {
                const feature = this.features_index[id]
                this[feature.type].splice(feature.key,1)
            }
        },
        handlePreview(){
            let data = this.content.data
            this.deleteOriginal(data.id)

            if (data.category === 'main') {
                this.main = data
            }
            else if (data.category === 'simple') {
                this.simple = data
            } else {
                this[data.category].push(data)
                this[data.category] = this.sortFeature(this[data.category])
            }
        }
    },
    created() {
        this.getHome()
    },
    mounted() {
        this.fill()
        if (window.googletag) {
            var googletag = window.googletag;
            googletag.cmd.push(function() {
                googletag.destroySlots()
                googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
                googletag.defineSlot('/1513505/v1_gweb_home_bloco_1', [[300, 100], [970, 250]], 'div-gpt-ad-1603501676998-0').addService(googletag.pubads());
                googletag.defineSlot('/1513505/v1_gweb_home_bloco_2', [[300, 100], [728, 90]], 'div-gpt-ad-1603501815620-0').addService(googletag.pubads());
                googletag.defineSlot('/1513505/v1_gweb_home_bloco_3', [[300, 100], [728, 90]], 'div-gpt-ad-1603501923878-0').addService(googletag.pubads());
                googletag.defineSlot('/1513505/v1_gweb_home_bloco_4', [[300, 100], [970, 250]], 'div-gpt-ad-1603501972574-0').addService(googletag.pubads());
                googletag.defineSlot('/1513505/v1_gweb_home_bloco_5', [[300, 100], [970, 250]], 'div-gpt-ad-1603502015774-0').addService(googletag.pubads());
                googletag.defineSlot('/1513505/v1_gweb_home_bloco_6', [[728, 90], [300, 100]], 'div-gpt-ad-1603502060044-0').addService(googletag.pubads());
                googletag.defineSlot('/1513505/v1_gweb_rodape', [[300, 100], [970, 250]], 'div-gpt-ad-1603502217781-0').addService(googletag.pubads());
                googletag.defineSlot('/1513505/v1_gweb_home_floating', [500, 375], 'div-gpt-ad-1611161341576-0').addService(googletag.pubads());
                
                googletag.pubads().enableSingleRequest();
                googletag.pubads().collapseEmptyDivs()
                googletag.enableServices();
                googletag.pubads().setTargeting('categoria', ['home-principal']).setTargeting('tipo_conteudo', ['home']);
                googletag.display('div-gpt-ad-1603501550614-0');
                googletag.display('div-gpt-ad-1603501676998-0');
                googletag.display('div-gpt-ad-1603501815620-0');
                googletag.display('div-gpt-ad-1603501923878-0');
                googletag.display('div-gpt-ad-1603501972574-0');
                googletag.display('div-gpt-ad-1603502015774-0');
                googletag.display('div-gpt-ad-1603502060044-0');
                googletag.display('div-gpt-ad-1603502217781-0');
                googletag.display('div-gpt-ad-1611161341576-0');
            })
        }
        window._ppads.checksBeforeLoad()

        if (this.content){
            this.handlePreview()
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$root.$emit('gazetaweb:closelive')
        next()
    }
}
</script>
